import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { find, isEmpty } from 'lodash';

const useOrderInfoStep = ({
  channel,
  getValues,
  setValue,
  useWatch,
  control
}) => {
  const { agentList: agents } = useSelector((state) => state.agentsReducer || { agentList: [] });
  const { salesChannels } = useSelector((s) => s.salesChannelsReducer);

  const agentValue = useWatch({
    name: 'agent_id',
    control
  });

  // Opciones
  const agentsOptions = useMemo(
    () => agents.map((row) => ({
      id: String(row.id),
      value: row.id,
      label: `${row.first_name} ${row.last_name}`,
      email: row.email
    })),
    [agents]
  );

  const salesChannelsOptions = useMemo(
    () => salesChannels.map((c) => ({
      id: String(c.id),
      value: c.id,
      label: c.title
    })),
    [salesChannels]
  );

  // Sincronizar agente
  useEffect(() => {
    const agentOpt = find(agentsOptions, { id: agentValue });
    if (agentOpt) {
      setValue('agent_name', agentOpt.label);
      setValue('agent_email', agentOpt.email);
    }
  }, [agentValue, agentsOptions, setValue]);

  // Canal por defecto
  useEffect(() => {
    if (isEmpty(salesChannelsOptions)) return;

    const currentValue = getValues('sales_channel_id');
    if (currentValue) return;

    const exists = find(salesChannelsOptions, {
      value: getValues('sales_channel_id')
    });

    if (!exists) {
      const channelDefined = find(salesChannels, {
        channel_type: channel
      });

      if (channelDefined) {
        setValue('sales_channel_id', String(channelDefined.id), {
          shouldDirty: false,
          shouldTouch: false
        });
      }
    }
  }, [salesChannelsOptions, salesChannels, channel, getValues, setValue]);

  return useMemo(() => ({
    agentsOptions,
    salesChannelsOptions
  }), [agentsOptions, salesChannelsOptions]);
};

export default useOrderInfoStep;
